const route = {
	getCareers: {
		endPoint: 'iarc/jobs?status=true',
		verb: 'get',
		isAuthRequired: false,
	},
	getProperties:{
		endPoint: 'iarc/asset',
		verb: 'get',
		isAuthRequired : false,
	},
	presignedUrl: {
		endPoint: 'iarc/presigned-url',
		verb: 'get',
		isAuthRequired: false,
	}
};

export { route };
